import { HStack, Spacer, Stack, useBreakpointValue, Separator } from '@chakra-ui/react'
import type { FC } from 'react'

import MetricTypePopover from '@app/next/metricTypePopover'
import DrawerHeaderActions from '@app/pages/strategies/components/drawer/drawerHeaderActions'
import { CardTitle } from '@app/shared/cards/components'
import { DomainObjectType } from '@app/shared/cards/components/cardTypeSection'
import FavoriteToggleButton from '@app/shared/favorites/favoriteToggleButton'
import { PageHeaderSection } from '@app/shared/layout'
import type { DomainMetric } from '@app/types'
import ICON_MAP, { COLOR_MAP } from '@app/utils/iconMap'

interface Props {
  metric: DomainMetric
  strategyId: string
}

const Header: FC<Props> = ({ metric, strategyId }) => {
  const { id, favoriteId } = metric

  return (
    <PageHeaderSection>
      <HStack pl={4}>
        <DomainObjectType type="Metric" title="Metric /" icon={ICON_MAP.Metric} color={COLOR_MAP.Metric}>
          <MetricTypePopover metric={metric} fontWeight="semibold" color={COLOR_MAP.Metric} />
        </DomainObjectType>
        <Spacer />
        <FavoriteToggleButton favoritableType="Metric" favoritableId={id} favoriteId={favoriteId} />
        <DrawerHeaderActions objId={metric.id} objType={metric.classType} strategyId={strategyId} />
      </HStack>
      <Separator />
      <Stack px={4}>
        <CardTitle domainObject={metric} name="name" fontSize={useBreakpointValue({ base: 'lg', md: 'xl' })} />
      </Stack>
    </PageHeaderSection>
  )
}

export default Header
